<template>
    <div class="form-wrapper">
        <ui-card
            class="form ui-card"
            :class="{ loading: formLoading }"
            title="Napisz do nas"
        >
            <form @submit.prevent="onContactFormSubmit">
                <TheDropdown
                    v-if="showDropdown"
                    class="mt-2 mb-0"
                    @onChange="onSubjectChange"
                    :options="selectSubjectOptions"
                    :selectedOption="selectedSubjectOption"
                    :text="'Czego dotyczy Twoja wiadomość'"
                />
                <div class="text-danger text-xs" v-if="invalidSubject">
                    Wybierz temat z listy.
                </div>
                <ui-virtual-list
                    class="mt-2"
                    style="font-size: 1rem"
                    :label="'Wskaż sklep, którego dotyczy sprawa'"
                    :name="'selectedMerchant'"
                    :moduleName="'user'"
                    :getter="'getUserLocationOptions'"
                    :multi="true"
                    :floatTitle="true"
                    :fetchAction="'merchantsFetch'"
                    :searcher="false"
                    :value="selectedMerchantsOption"
                    :allOption="true"
                    :allOptionLabelText="'Wszystkie'"
                    @change="onChangeSelectedMerchants"
                />
                <div class="text-danger text-xs" v-if="invalidMerchants">
                    Wskaż przynajmniej jeden sklep.
                </div>
                <TheTextArea
                    :textareaName="'contactFormTextarea'"
                    :minlength="20"
                    v-model="contactTextareaText"
                    :required="true"
                    :label="'Twoja wiadomość'"
                    class="mt-2 mb-0"
                    customStyle="height:100%"
                />
                <phone-input
                    class="cux-exclude mb-4 mt-2"
                    :phoneValue="phoneValue"
                    :placeholder="'Telefon kontaktowy'"
                    :invalidPhone="invalidPhone"
                    @setInvalidPhoneValue="val => (this.invalidPhone = val)"
                    @onChange="changePhone($event)"
                ></phone-input>
                <the-btn
                    :text="'Wyślij wiadomość'"
                    class="btn btn-secondary"
                ></the-btn>
                <span class="contact-form-disclaimer">
                    Administratorem Pani/Pana danych osobowych jest Innowacyjna
                    Platforma Handlu sp. z o.o. z siedzibą w Komornikach przy
                    ul. Wiśniowej 11, 62–052 Komorniki. Dane podane przez
                    Panią/Pana w powyższym formularzu będą przetwarzane w celu
                    kontaktu i obsługi Pani/Pana zgłoszenia. Więcej informacji o
                    przetwarzaniu danych osobowych, w tym o przysługujących
                    Pani/Panu prawach, dostępnych jest pod adresem
                    <span
                        class="disclaimer-link"
                        @click.prevent="
                            $store.dispatch('openModal', {
                                component: 'ModalCookies'
                            })
                        "
                    >
                        Polityka Prywatności
                    </span>
                </span>
            </form>
        </ui-card>
        <div v-if="formLoading" class="contact-form-cover">
            <div>Wysyłanie wiadomości...</div>
            <ButtonSpinnerVue status="loading" />
        </div>
    </div>
</template>

<script>
import { UiCard, TheDropdown, TheTextArea } from '../../global/ui'
import ButtonSpinnerVue from '../../global/ui/ButtonSpinner.vue'
export default {
    name: 'ContactForm',
    components: { UiCard, TheDropdown, TheTextArea, ButtonSpinnerVue },
    data() {
        return {
            showDropdown: true,
            formLoading: false,
            selectedSubjectOption: null,
            selectedMerchantsOption: [],
            contactTextareaText: '',
            phoneValue: '',
            invalidPhone: false,
            invalidSubject: false,
            invalidMerchants: false,
            selectConfig: [
                {
                    value: '1',
                    label: 'Problem techniczny – promocje',
                    supportMail:
                        process.env.VUE_APP_TECHNICAL_CONTACT_FORM_EMAIL
                },
                {
                    value: '2',
                    label: 'Problem techniczny – stanowisko kasowe',
                    supportMail:
                        process.env.VUE_APP_TECHNICAL_CONTACT_FORM_EMAIL
                },
                {
                    value: '3',
                    label: 'Problem techniczny – Panel Detalisty',
                    supportMail:
                        process.env.VUE_APP_TECHNICAL_CONTACT_FORM_EMAIL
                },
                {
                    value: '4',
                    label: 'Inne problemy techniczne',
                    supportMail:
                        process.env.VUE_APP_TECHNICAL_CONTACT_FORM_EMAIL
                },
                {
                    value: '5',
                    label: 'Problem z rozliczeniem',
                    supportMail:
                        process.env.VUE_APP_OPERATIONS_CONTACT_FORM_EMAIL
                },
                {
                    value: '6',
                    label:
                        'Zmiana Danych, Rachunek Bankowy, Dane Detalisty, itp.',
                    supportMail:
                        process.env.VUE_APP_OPERATIONS_CONTACT_FORM_EMAIL
                },
                {
                    value: '7',
                    label: 'RODO - bezpieczeństwo moich danych osobowych',
                    supportMail: process.env.VUE_APP_GDPR_CONTACT_FORM_EMAIL
                }
            ]
        }
    },
    created() {
        this.$store.dispatch('extendedDataFetch', {
            includes: 'locations'
        })
    },
    computed: {
        userEmail() {
            return this.$store.getters.getUser.email
        },
        userNip() {
            return this.$store.getters.getUserCompaniesData.map(e => e.nip)
        },
        selectSubjectOptions() {
            return this.selectConfig.map(e => {
                return {
                    label: e.label,
                    value: e.value
                }
            })
        },
        selectMerchantsOptions() {
            return this.$store.getters.getUserLocationOptions
        }
    },
    methods: {
        clearForm() {
            this.contactTextareaText = ''
            this.selectedSubjectOption = null
            this.selectedMerchantsOption = []
            this.showDropdown = false
            this.$nextTick(() => {
                this.showDropdown = true
            })
        },
        onSubjectChange(val) {
            if (this.invalidSubject) {
                this.invalidSubject = false
            }
            if (val > 4) {
                this.invalidMerchants = false
            }
            this.selectedSubjectOption = val
        },
        onContactFormSubmit() {
            if (!this.selectedSubjectOption) {
                this.invalidSubject = true
            }
            if (
                !this.selectedMerchantsOption.length &&
                this.selectedSubjectOption < 5
            ) {
                this.invalidMerchants = true
            }
            const selectedSubjectOption = this.selectConfig.find(
                e => e.value === this.selectedSubjectOption
            )
            if (
                this.invalidPhone ||
                this.invalidSubject ||
                this.invalidMerchants ||
                !selectedSubjectOption
            ) {
                return
            }
            this.formLoading = true

            const title = selectedSubjectOption.label

            let selectedMerchantsTitle = null

            if (this.selectedMerchantsOption.length) {
                selectedMerchantsTitle = this.selectedMerchantsOption
                    .map(v => {
                        return this.selectMerchantsOptions.find(
                            el => el.value === v
                        ).label
                    })
                    .join(', ')
            }

            const supportMail = selectedSubjectOption.supportMail

            let baseMailTitle = `${title}`

            if (this.userNip) {
                baseMailTitle += `; NIP ${this.userNip.toString()}`
            }

            const userMailTitle = `Potwierdzenie przekazania formularza (${title})`

            let mailMessage = ''
            if (selectedMerchantsTitle) {
                mailMessage += `Sklepy, których dotyczy sprawa: ${selectedMerchantsTitle}<br/><br/>`
            }
            if (this.phoneValue) {
                mailMessage += `Telefon kontaktowy: +48${this.phoneValue}<br/><br/>`
            }
            mailMessage += `Treść wiadomości:<br/><br/>${this.contactTextareaText}`

            let userMailMessage = `Szanowny Kliencie,<br/><br/>otrzymaliśmy od Ciebie następującą wiadomość (${title}):<br/><br/>${this.contactTextareaText}<br/><br/>`
            if (selectedMerchantsTitle) {
                userMailMessage += `Sklepy, których dotyczy sprawa: ${selectedMerchantsTitle}<br/><br/>`
            }
            userMailMessage +=
                'Nasi pracownicy z uwagą zapoznają się z wiadomością od Ciebie. Dołożymy wszelkich starań, abyś otrzymał odpowiedź w jak najkrótszym czasie.<br/><br/>W razie pytań prosimy o kontakt z infolinią:<br/>T: 22 12 91 400<br/>E: bok@europlatform.pl<br/><br/>Pozdrawiamy<br/>Zespół EuroPlatform'

            const userMailData = {
                to: this.userEmail,
                subject: userMailTitle,
                content: userMailMessage
            }
            const supportMailData = {
                to: supportMail,
                subject: baseMailTitle,
                content: mailMessage
            }

            const userMailPromise = this.$store.dispatch(
                'sendEmail',
                userMailData
            )
            const supportMailPromise = this.$store.dispatch(
                'sendEmail',
                supportMailData
            )

            Promise.all([userMailPromise, supportMailPromise])
                .then(() => {
                    this.clearForm()

                    this.$store.dispatch('addNotification', {
                        type: 'success',
                        content: 'Wiadomość wysłana poprawnie'
                    })
                })
                .catch(() => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd. Spróbuj ponownie później.'
                    })
                })
                .finally(() => {
                    this.formLoading = false
                })
        },
        changePhone(event) {
            this.phoneValue = event?.replaceAll(/[-]/g, '').replace('+48 ', '')
        },
        onChangeSelectedMerchants(event) {
            this.selectedMerchantsOption = event
            if (event && event.length && this.invalidMerchants) {
                this.invalidMerchants = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.form-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    .form {
        height: 100%;
        display: flex;
        flex-direction: column;
        &.loading {
            filter: blur(2px);
            -webkit-filter: blur(2px);
        }
        form {
            display: flex;
            flex-direction: column;
            min-height: 90%;
        }
    }
    .contact-form-cover {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(255, 255, 255, 0.4);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #000;
    }
    .contact-form-disclaimer {
        padding-top: 1rem;
        font-size: 14px;

        .disclaimer-link {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
    }
}
</style>
